<script>
export default {
  name: "MainHeader",
  props: {
    isFormSubmitted: Boolean, // Dies deklariert die erwartete Prop
    backdrop: {},
  },

  data() {
    return {
      showElement: false,
      showMenu: null,
    }
  },
  watch: {
    isFormSubmitted(showThreeJs) {
      if (showThreeJs === true) {
        this.showElement = true;
      }
    },
    backdrop(newVal) {
      this.showMenu = newVal;
    }
  },
  methods: {
    openSmallPopup() {
      this.$emit('toggleSmallPopup', {opened: true, step: 0})
    },

  },
}
</script>

<template>
  <header>
    <span>
      <a href="https://www.nrwglobalbusiness.com/de/">
      <img src="@/assets/img/nrwgblogo.svg"/>
        </a>
    </span>
    <div v-if="showElement" class="flex-wrapper flex-column flex-end">
      <div style="width:auto" :class="{'hideZindex': !showMenu}" class="openmenu_wrapper">
        <span>{{$t('general.menulabel')}}</span>
        <a style="width:auto" class="button openmenu" href="#">
          <svg style="height:30px;" id="testo" xmlns="http://www.w3.org/2000/svg" width="22.945" height="21.945"
               viewBox="0 0 22.945 22.945">
            <g id="Gruppe_6076" data-name="Gruppe 6076" transform="translate(-1749.5 -67.5)">
              <line class="upper" id="Linie_1" data-name="Linie 1" x2="20.922"
                    transform="translate(1750.5 68.5)"
                    fill="none" stroke="#fff" stroke-linecap="round" stroke-width="2"/>
              <line class="middle" id="Linie_2" data-name="Linie 2" x2="20.922"
                    transform="translate(1750.5 77.122)"
                    fill="none" stroke="#fff" stroke-linecap="round" stroke-width="2"/>
              <line class="lower" id="Linie_3" data-name="Linie 3" x2="20.922"
                    transform="translate(1750.5 85.743)"
                    fill="none" stroke="#fff" stroke-linecap="round" stroke-width="2"/>
            </g>
            <g id="Gruppe_7895" data-name="Gruppe 7895" transform="translate(1.414 1.414)">
              <line id="Linie_4" data-name="Linie 4" x2="20.117" y2="20.117" transform="translate(0 0)"
                    fill="none" stroke="#fff" stroke-linecap="round" stroke-width="2"></line>
              <line id="Linie_5" data-name="Linie 5" x2="20.117" y2="20.117"
                    transform="translate(20.117 0) rotate(90)" fill="none" stroke="#fff"
                    stroke-linecap="round" stroke-width="2"></line>
            </g>

          </svg>

        </a>
      </div>
      <div @click="openSmallPopup" v-if="showElement" class="herowrapper">
        <div class="outline-wrapper">
          <div class="outline-wrapper-inner">
            <img src="@/assets/img/male_nooutline.png">
          </div>
        </div>
        <div class="outline-wrapper">
          <div class="outline-wrapper-inner">
            <img src="@/assets/img/female_nooutline.png">
          </div>

        </div>
      </div>
    </div>
  </header>
</template>

<style lang="scss" scoped>
@import 'src/assets/css/main';
@import 'src/assets/css/layout/header';

</style>
